// src/components/ReusableSearchBar/ReusableSearchBar.jsx
import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";

const ReusableSearchBar = ({
  value,
  onChange,
  placeholder = "Search...",
  width = "300px",
  minWidth = "250px",
  maxWidth = "400px",
  className = "",
}) => {
  return (
    <TextField
      type="search"
      placeholder={placeholder}
      variant="outlined"
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`search-input ${className}`}
      style={{
        minWidth,
        maxWidth,
        width,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search className="text-[#D8D8D8]" />
          </InputAdornment>
        ),
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "50px",
          backgroundColor: "transparent",
          color: "rgba(216, 216, 216, 1)",
          "& fieldset": {
            borderColor: "rgba(229, 229, 229, 0.5)",
          },
          "&:hover fieldset": {
            borderColor: "rgba(229, 229, 229, 0.75)",
          },
          "&.Mui-focused fieldset": {
            borderColor: "rgba(229, 229, 229, 1)",
          },
        },
        "& .MuiInputBase-input": {
          color: "#D8D8D8",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "rgba(229, 229, 229, 0.5)",
          opacity: 1,
        },
      }}
    />
  );
};

export default ReusableSearchBar;